import { RootState } from 'src/state/rootReducer';

export const getPointsData = (state: RootState) => {
  return state.entities.points;
};

export const savePointsLoading = (state: RootState) => {
  return state.entities.points.saving;
};
